// What saving a draft Boo name would send: the trimmed name, or null when
// there's nothing to save (blank, or the same as the current name).
export function renameTarget(draft: string, current: string): string | null {
  const name = draft.trim();
  if (!name || name === current) return null;
  return name;
}
